// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"b2df4501","453":"056e4bf2"}[chunkId] + ".chunk.js";
};